import { NgxsModuleOptions } from '@ngxs/store';

export const ngxsConfig: NgxsModuleOptions = {
    selectorOptions: {
        suppressErrors: false, 
        injectContainerState: false
    }
}